import { instance, getApiDomain } from '@cognitivecredit/ui-utils'
import { useChatAppStore } from '@/piniaStores/chatAppStore.ts'
import { storeToRefs } from 'pinia'

export const chatAppBeforeHook = async (to, next) => {
  const chatAppStore = useChatAppStore()
  const { threads } = storeToRefs(chatAppStore)
  const { setCurrentThread, fetchThreadsHistory } = chatAppStore

  if (to.query.id) {
    try {
      const req = await instance({ apiDomain: getApiDomain('chat-ai') })

      if (!threads.value.length) {
        await fetchThreadsHistory()
      }

      const res = await req.get(`/ai/threads/${to.query.id}`)

      const thread = threads.value.find((t) => t.id === to.query.id)
      if (thread) {
        const messages = res.data.map((msg) => ({
          id: crypto.randomUUID(),
          isCollapsed: false,
          ...msg,
        }))
        setCurrentThread({ ...thread, messages })
        next()
      } else {
        next({ name: 'Cognitive Credit AI' })
      }
    } catch (error) {
      console.error('Error fetching thread:', error)
      next({ name: 'Cognitive Credit AI' })
    }
  } else {
    next({ name: 'Cognitive Credit AI' })
  }
}
